import React from "react";
import styles from "./NextVisit.module.scss";
import { getCountryFromUrl } from "../utils/helpers";

const NextVisit = () => {
  const country = getCountryFromUrl();

  const countryLinks = {
    us: "https://www.flightclubdartsusa.com?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
    ie: "https://flightclubdarts.com/ie/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
    aus: "https://flightclubdarts.com.au/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit",
  };

  const ukLink = "https://flightclubdarts.com/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit";

  const countryLink = countryLinks[country] || ukLink;

  return (
    <div className={`${styles.nextVisit} section section--padded`}>
      <h3>Round two?</h3>
      <p>Lock in your next game.</p>
      <a href={countryLink} className={styles.ctaButton} target="_blank" rel="noopener noreferrer">
        PLAN YOUR NEXT VISIT
      </a>
    </div>
  );
};

export default NextVisit;
